var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval21A = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M29.5 26.5A2.5 2.5 0 0 1 27 29H15.5a2.5 2.5 0 0 1-2.5-2.5v-10a2.5 2.5 0 0 1 2.5-2.5h14v12.5ZM47 26.5a2.5 2.5 0 0 1-2.5 2.5H33a2.5 2.5 0 0 1-2.5-2.5V14h14a2.5 2.5 0 0 1 2.5 2.5v10Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M47 24v-7.5a2.5 2.5 0 0 0-2.5-2.5h-29a2.5 2.5 0 0 0-2.5 2.5V24"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M14 40a6 6 0 0 1 6-6h20a6 6 0 0 1 0 12H20a6 6 0 0 1-6-6Z"
})));
SvgOval21A.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval21A);
export default ForwardRef;